const INPUT_TYPES = new Set([
  'TextInput',
  'TextArea',
  'Dropdown',
  'RadioButtonsGroup',
  'CheckboxGroup',
  'DatePicker',
  'OptIn'
]);

const normalizeLabel = (label = '') => label.toLowerCase().trim();

const findPreviewValue = (label, previewFields = []) => {
  const normalized = normalizeLabel(label);
  const exact = previewFields.find((field) => normalizeLabel(field.label) === normalized);
  if (exact?.value) return exact.value;

  const partial = previewFields.find((field) => {
    const previewLabel = normalizeLabel(field.label);
    return normalized.includes(previewLabel) || previewLabel.includes(normalized);
  });

  return partial?.value;
};

const firstOptionTitle = (field) => field['data-source']?.[0]?.title || '—';

const firstOptionsTitles = (field, count = 2) => {
  const titles = (field['data-source'] || []).slice(0, count).map((option) => option.title);
  return titles.length > 0 ? titles.join(', ') : '—';
};

const mapFieldToPreview = (field, previewFields) => {
  const label = field.label || field.name || '';
  const previewValue = findPreviewValue(label, previewFields);

  switch (field.type) {
    case 'TextArea':
      return { label, value: previewValue || '...', isMultiline: true };
    case 'Dropdown':
    case 'RadioButtonsGroup':
      return { label, value: previewValue || firstOptionTitle(field), isSelect: true };
    case 'DatePicker':
      return { label, value: previewValue || '25/08/2026' };
    case 'CheckboxGroup':
      return { label, value: previewValue || firstOptionsTitles(field), isMultiselect: true };
    case 'OptIn':
      return { label, value: previewValue || 'Aceptado', isOptIn: true };
    default:
      return { label, value: previewValue || '—' };
  }
};

const extractFormChildren = (screen) => {
  const layoutChildren = screen?.layout?.children || [];
  const form = layoutChildren.find((child) => child.type === 'Form');
  return form?.children || [];
};

const parseFlowJsonPreview = (flowJson, previewFields = []) => {
  const screens = flowJson?.screens;
  if (!Array.isArray(screens) || screens.length === 0) return [];

  return screens.map((screen) => {
    const layoutChildren = screen.layout?.children || [];
    const heading = layoutChildren.find((child) => child.type === 'TextHeading')?.text;
    const body = layoutChildren.find((child) => child.type === 'TextBody')?.text;
    const formChildren = extractFormChildren(screen);
    const footer = formChildren.find((child) => child.type === 'Footer');
    const inputFields = formChildren.filter(
      (child) => INPUT_TYPES.has(child.type) && child.name
    );

    const actionName = footer?.['on-click-action']?.name;

    return {
      id: screen.id,
      title: screen.title || '',
      heading,
      body,
      fields: inputFields.map((field) => mapFieldToPreview(field, previewFields)),
      submitLabel: footer?.label || 'Enviar',
      isTerminal: Boolean(screen.terminal) || actionName === 'complete'
    };
  });
};

export default parseFlowJsonPreview;
